'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var breakpoints = {
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
};
exports["default"] = breakpoints;